import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, LoadingController, ModalController, NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { ChangeSecondatyTitleAction, ChangeTitleAction, UseI18nOnTitleAction } from '../../../angular-wallet-base/actions/appSettings.actions';
import { EpinClaimSuccessComponent } from '../../../components/epin-claim-success/epin-claim-success.component';
import { EpinManagerService } from '../../../angular-wallet-base/services/epin-manager.service';
import { TranslateService } from '@ngx-translate/core';
import { getTokenInfo, isEnterKey } from '../../../angular-wallet-base/utils';
import { getKeychain } from '../../../angular-wallet-base/store/wallet';
import { CoinGeckoService } from '../../../angular-wallet-base/services/coingecko.service';
import { PriceOracleService } from '../../../angular-wallet-base/services/price-oracle.service';
import BigNumber from 'bignumber.js';
import { GetAllTokenBalancesAction } from '../../../angular-wallet-base/actions/wallet.actions';
import { AGX_GUID } from 'src/app/angular-wallet-base/constants';
import { Logger } from '../../../angular-wallet-base/services/logger.service';
import { createKeyringId } from '../../../angular-wallet-base/keyringUtils';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';
import { SubscriptionListenerComponent } from '../../../angular-wallet-base/SubscriptionListenerComponent';
import { MembersPortalService } from "../../../angular-wallet-base/services/members-portal.service";
import { BuyLearnMoreComponent } from '../../../components/buy-learn-more/buy-learn-more.component';
@Component({
  selector: 'app-claim-epin',
  templateUrl: './claim-epin.component.html',
  styleUrls: ['./claim-epin.component.scss'],
})
export class ClaimEpinComponent extends SubscriptionListenerComponent implements OnInit, OnDestroy {
  public epin: string;
  public loading: boolean = false;
  private currentBalance: number;
  public hideForm: boolean = false;
  private fiatValue: number;
  public hidePurchaseText: boolean;
  private totalPurchased: number;
  private loadingModal;
  private secondLoadingModal;
  public tokenInfo;
  public tokenSymbol;
  public tokenGuid;
  public baseChainSymbol;
  public isDesktopMode;
  public epinClaimed = false;
  public epinClaimedInfo: any = {};

  constructor(
    protected store: Store<AppState>,
    public nav: NavController,
    private route: ActivatedRoute,
    private modalController: ModalController,
    private epinManager: EpinManagerService,
    private alertController: AlertController,
    private translate: TranslateService,
    private loadingController: LoadingController,
    private coingeckoService: CoinGeckoService,
    private oraclePriceService: PriceOracleService,
    private activatedRoute: ActivatedRoute,
    private appMode: AppModeService,
    private membersPortal: MembersPortalService,
  ) {
    super(store);
    this.epin = this.route.snapshot.params['epin'];
  }

  async openLearnMoreModal() { // For showing token details popup (for mobile)
    let token = await this.membersPortal.getModalInfo()
    const modal = await this.modalController.create({
      component: BuyLearnMoreComponent,
      componentProps: {
        token,
        mode: 'mobile',
        showPurchase: false
      }
    });

    await modal.present();
  }
  async ngOnInit() {
    this.baseChainSymbol = this.activatedRoute.snapshot.queryParams.baseChainSymbol;
    this.tokenGuid = this.activatedRoute.snapshot.queryParams.guid;
    this.tokenSymbol = this.activatedRoute.snapshot.queryParams.symbol;

    this.hidePurchaseText = this.route.snapshot.queryParams.hidePurchaseText;
    this.subscriptions.add(this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode));
    this.subscriptions.add(this.store.select(getKeychain).subscribe(async keychain => {
      try {
        this.tokenInfo = getTokenInfo(keychain, this.getActiveKeyringId());
        this.currentBalance = this.tokenInfo.balance;
        const agxMarkup: any = await this.oraclePriceService.getMarkup(this.tokenSymbol.toLowerCase());
        const agxPrice = await this.oraclePriceService.getSpotPrice(this.tokenSymbol.toLowerCase());
        this.fiatValue = agxMarkup * (Number(agxPrice[0].lastPrice));
      } catch (err) {
        Logger.error(err);
        this.currentBalance = 0;
      }
    }));

    //this.mockModal();
  }

  async ngAfterViewInit() {
    const i18nTitle = await this.translate.get('buy_agx.title_one', { tokenSymbol: this.tokenSymbol.toUpperCase() }).toPromise();
    const i18nSecondaryTitle = await this.translate.get('buy_agx.title_two').toPromise();
    this.store.dispatch(new ChangeTitleAction(i18nTitle));
    this.store.dispatch(new ChangeSecondatyTitleAction(i18nSecondaryTitle));
    this.store.dispatch(new UseI18nOnTitleAction(false));
  }

  async mockModal() {
    const epinSuccessModal = await this.modalController.create({
      component: EpinClaimSuccessComponent,
      componentProps: {
        tokenSymbol: this.tokenSymbol,
        tokenGuid: this.tokenGuid,
        baseChainSymbol: this.baseChainSymbol,
        epinBalance: '25.00',
        newBalance: '2356.34',
        logo: this.tokenInfo.logo
      }
    });
    await epinSuccessModal.present();
  }

  getActiveKeyringId() {
    return createKeyringId(this.baseChainSymbol, this.tokenGuid)
  }

  backToBuyEpin() {
    this.nav.navigateForward(['/wallet/buy-tokens/step-one'], { queryParams: { symbol: this.tokenSymbol, guid: this.tokenGuid, baseChainSymbol: this.baseChainSymbol }});
  }

  async showEpinInfo() {
    const alert = await this.alertController.create({
      header: await this.translate.get('buy_agx.claim_epin.epin').toPromise(),
      message: await this.translate.get('buy_agx.claim_epin.epin_help').toPromise()
    });

    await alert.present();
  }

  ngOnDestroy() {
    this.loading = false;
    this.hideForm = false;

    if (this.loadingModal) {
      this.loadingModal.dismiss();
    }
    if (this.secondLoadingModal) {
      this.secondLoadingModal.dismiss();
    }
  }

  checkEpinIsValid() {
    return !/\D/g.test(this.epin);
  }

  async onSubmit() {
    if (!this.checkEpinIsValid()) {
      const errorDialog = await this.alertController.create({
        header: await this.translate.get('buy_agx.claim_epin.error_title').toPromise(),
        message: await this.translate.get('buy_agx.claim_epin.error_wrong_epin').toPromise()
      });

      return errorDialog.present();
    }

    const tokenBacking = this.tokenGuid === AGX_GUID ? (await this.translate.get('buy_agx.silver_label').toPromise()) : (await this.translate.get('buy_agx.gold_label').toPromise());
    this.secondLoadingModal = await this.loadingController.create({
      message: await this.translate.get('buy_agx.loading.converting', { tokenBacking, tokenSymbol: this.tokenSymbol }).toPromise(),
      duration: 10000
    });
    await this.secondLoadingModal.present();

    this.loading = true;
    let pinInfo;
    // Initializing just in case it's needed.
    const errorDialog = await this.alertController.create({
      header: await this.translate.get('buy_agx.claim_epin.error_title').toPromise(),
      message: await this.translate.get('buy_agx.claim_epin.error_description').toPromise()
    });

    try {
      pinInfo = await this.epinManager.getEpinInfo(this.epin, this.tokenSymbol);
    } catch (err) {
      let getEpinErrorDialog
      Logger.info('Error while checking epin balance: ', err)

      if (err.name === "TimeoutError") {
        getEpinErrorDialog = await this.alertController.create({
          header: await this.translate.get('buy_agx.claim_epin.error_title').toPromise(),
          message: err.message
        });
      } else if (err.error.errorCode === 'members_portal_error') {
        getEpinErrorDialog = await this.alertController.create({
          header: await this.translate.get('buy_agx.claim_epin.error_title').toPromise(),
          message: await this.translate.get('buy_agx.claim_epin.members_portal_error').toPromise()
        });
      } else if (err.error.message) {
        getEpinErrorDialog = await this.alertController.create({
          header: await this.translate.get('buy_agx.claim_epin.error_title').toPromise(),
          message: err.error.message
        });
      } else {
        getEpinErrorDialog = await this.alertController.create({
          header: await this.translate.get('buy_agx.claim_epin.error_title').toPromise(),
          message: await this.translate.get('buy_agx.claim_epin.error_wrong_epin').toPromise()
        });
      }

      this.loading = false;
      await this.secondLoadingModal.dismiss();
      await getEpinErrorDialog.present();
      return;
    }

    // Hides form in the background
    this.hideForm = true;

    const pinBalance = new BigNumber(Number(pinInfo.tokenAmount));

    try {
      await this.epinManager.redeemEpin(this.epin, this.tokenSymbol.toLowerCase());
      this.store.dispatch(new GetAllTokenBalancesAction());
    } catch (err) {
      Logger.info('Error while redeeming epin: ', err)
      this.loading = false;
      this.hideForm = false;
      await this.secondLoadingModal.dismiss();

      if (err.error.errorCode === 'members_portal_error') {
        const membersPortalError = await this.alertController.create({
          header: await this.translate.get('buy_agx.claim_epin.error_title').toPromise(),
          message: await this.translate.get('buy_agx.claim_epin.members_portal_error').toPromise()
        });

        await membersPortalError.present();
      } else if (err.error.errorCode === 'not_enough_funds') {
        const notEnoughFundsError = await this.alertController.create({
          header: await this.translate.get('buy_agx.claim_epin.error_title').toPromise(),
          message: await this.translate.get('buy_agx.claim_epin.not_enough_funds').toPromise()
        });

        await notEnoughFundsError.present();
      } else if (err.error.message) {
        const otherError = await this.alertController.create({
          header: await this.translate.get('buy_agx.claim_epin.error_title').toPromise(),
          message: err.error.message
        });
        await otherError.present()
      } else {
        await errorDialog.present();
      }
      return;
    }
    this.loading = false;
    this.hideForm = false;
    await this.secondLoadingModal.dismiss();

    if (this.isDesktopMode) {
      this.epinClaimedInfo.pinBalance = new BigNumber(Number(pinInfo.tokenAmount));
      this.epinClaimedInfo.pinBalanceFormatted = this.toFixedDown(this.epinClaimedInfo.pinBalance, 2);
      this.epinClaimedInfo.newBalance = Number(this.currentBalance) + (pinBalance.multipliedBy(100000000).toNumber());
      this.epinClaimed = true;
    } else {
      const epinSuccessModal = await this.modalController.create({
        component: EpinClaimSuccessComponent,
        componentProps: {
          tokenSymbol: this.tokenSymbol,
          tokenGuid: this.tokenGuid,
          baseChainSymbol: this.baseChainSymbol,
          epinBalance: this.toFixedDown(pinBalance, 2),
          newBalance: Number(this.currentBalance) + (pinBalance.multipliedBy(100000000).toNumber()), // converting pin balance to satoshi
          logo: this.tokenInfo.logo
        }
      });
      await epinSuccessModal.present();
    }
  }

  toFixedDown(float, digits) {
    const re = new RegExp(`(\\d+\\.\\d{${digits}})(\\d)`);
    const match = float.toString().match(re);
    return match ? parseFloat(match[1]) : float.valueOf();
  }

  onKeyUp(ev) {
    if (isEnterKey(ev)) {
      this.onSubmit();
    }
  }

}
